export const sampleClips = [
    {
        segmentId: "clip-01",
        rotateAngleDegrees: 0,
        caption: { title: "Richard Alexander Anderson 🙃", subtitle: "New York" },
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-01.mp4",
        ],
        skipFace: false,
        durationSeconds: 25.7,
        width: 1280,
        height: 720,
        faces: [
            {
                width: 678,
                height: 664,
                durationSeconds: 10.000000000000002,
                urls: [
                    "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-01-face.mp4",
                ],
                faceLocations: [
                    {
                        timeInSeconds: 0,
                        boxRaw: [
                            0.08828125000000003, 0.12222222222222223, 0.8053097345132744,
                            0.822289156626506,
                        ],
                        score: 0.67,
                    },
                    {
                        timeInSeconds: 0.5,
                        boxRaw: [
                            0.07656250000000003, 0.10138888888888889, 0.831858407079646,
                            0.8509036144578314,
                        ],
                        score: 0.62,
                    },
                    {
                        timeInSeconds: 1,
                        boxRaw: [
                            0.08515624999999999, 0.11249999999999999, 0.8289085545722714,
                            0.8478915662650602,
                        ],
                        score: 0.65,
                    },
                    {
                        timeInSeconds: 1.5,
                        boxRaw: [
                            0.08750000000000002, 0.09722222222222221, 0.7109144542772862,
                            0.7259036144578312,
                        ],
                        score: 0.74,
                    },
                    {
                        timeInSeconds: 2,
                        boxRaw: [
                            0.0546875, 0.0625, 0.8451327433628318, 0.8629518072289156,
                        ],
                        score: 0.69,
                    },
                    {
                        timeInSeconds: 2.5,
                        boxRaw: [
                            0.06406250000000002, 0.08194444444444443, 0.8067846607669616,
                            0.8237951807228916,
                        ],
                        score: 0.74,
                    },
                    {
                        timeInSeconds: 3,
                        boxRaw: [
                            0.008593750000000011, 0.05555555555555555, 0.9203539823008849,
                            0.9397590361445783,
                        ],
                        score: 0.65,
                    },
                    {
                        timeInSeconds: 3.5,
                        boxRaw: [
                            0.022656250000000017, 0.08611111111111111, 0.8510324483775811,
                            0.8689759036144579,
                        ],
                        score: 0.63,
                    },
                    {
                        timeInSeconds: 4,
                        boxRaw: [
                            0.0031250000000000167, 0.03888888888888889, 0.9380530973451328,
                            0.9578313253012049,
                        ],
                        score: 0.7,
                    },
                    {
                        timeInSeconds: 4.5,
                        boxRaw: [
                            0.0031250000000000167, 0.009722222222222215, 0.9705014749262537,
                            0.9894578313253012,
                        ],
                        score: 0.69,
                    },
                    {
                        timeInSeconds: 5,
                        boxRaw: [
                            0.05546875000000001, 0.08333333333333334, 0.7905604719764012,
                            0.8072289156626506,
                        ],
                        score: 0.65,
                    },
                    {
                        timeInSeconds: 5.5,
                        boxRaw: [0, 0, 1, 1.0225903614457832],
                        score: 0.69,
                    },
                    {
                        timeInSeconds: 6,
                        boxRaw: [
                            0.0062500000000000056, 0.012499999999999997, 0.967551622418879,
                            0.9879518072289156,
                        ],
                        score: 0.65,
                    },
                    {
                        timeInSeconds: 6.5,
                        boxRaw: [
                            0.05390624999999999, 0.08333333333333334, 0.7979351032448377,
                            0.8162650602409639,
                        ],
                        score: 0.63,
                    },
                    {
                        timeInSeconds: 7,
                        boxRaw: [
                            0.0007812500000000111, 0.015277777777777779, 0.9660766961651918,
                            0.9864457831325302,
                        ],
                        score: 0.66,
                    },
                    {
                        timeInSeconds: 7.5,
                        boxRaw: [
                            0.0007812500000000111, 0.015277777777777779, 0.9690265486725663,
                            0.9909638554216867,
                        ],
                        score: 0.71,
                    },
                    {
                        timeInSeconds: 8,
                        boxRaw: [
                            0.0023437500000000056, 0.01805555555555556, 0.9778761061946902,
                            0.9984939759036144,
                        ],
                        score: 0.74,
                    },
                    {
                        timeInSeconds: 8.500000000000002,
                        boxRaw: [
                            0.00390625, 0.022222222222222227, 0.9690265486725663,
                            0.9879518072289156,
                        ],
                        score: 0.62,
                    },
                    {
                        timeInSeconds: 9.000000000000002,
                        boxRaw: [
                            0.05312500000000003, 0.08194444444444443, 0.8082595870206489,
                            0.8268072289156626,
                        ],
                        score: 0.65,
                    },
                    {
                        timeInSeconds: 9.500000000000002,
                        boxRaw: [
                            0.0007812500000000111, 0.02361111111111111, 0.9660766961651918,
                            0.9849397590361446,
                        ],
                        score: 0.71,
                    },
                    {
                        timeInSeconds: 10.000000000000002,
                        boxRaw: [
                            0.0031250000000000167, 0.03194444444444444, 0.9365781710914455,
                            0.9563253012048193,
                        ],
                        score: 0.74,
                    },
                ],
            },
        ],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-01-thumb.jpg",
    },
    {
        segmentId: "clip-02",
        rotateAngleDegrees: 0,
        caption: {
            title: "Z",
            subtitle: "Ontario 🇨🇦",
        },
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-02.mp4",
        ],
        skipFace: false,
        durationSeconds: 40.566667,
        width: 406,
        height: 720,
        faces: [
            {
                width: 384,
                height: 399,
                durationSeconds: 10,
                urls: [
                    "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-02-face.mp4",
                ],
                faceLocations: [
                    {
                        timeInSeconds: 0,
                        boxRaw: [
                            0.01724137931034482, 0.004166666666666652, 1, 0.9598997493734336,
                        ],
                        score: 0.84,
                    },
                    {
                        timeInSeconds: 0.5,
                        boxRaw: [
                            0.0049261083743842304, 0.001388888888888884, 0.96875,
                            0.9323308270676693,
                        ],
                        score: 0.81,
                    },
                    {
                        timeInSeconds: 1,
                        boxRaw: [
                            0.0024630541871921152, 0, 0.9713541666666666, 0.9348370927318297,
                        ],
                        score: 0.81,
                    },
                    {
                        timeInSeconds: 1.5,
                        boxRaw: [
                            0.007389162561576353, 0.005555555555555536, 0.96875,
                            0.9323308270676693,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 2,
                        boxRaw: [
                            0.009852216748768475, 0.008333333333333331, 0.9947916666666666,
                            0.9548872180451128,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 2.5,
                        boxRaw: [
                            0, 0.009722222222222215, 1.0026041666666667, 0.9649122807017544,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 3,
                        boxRaw: [
                            0.01231527093596059, 0.005555555555555536, 1.0234375,
                            0.9849624060150375,
                        ],
                        score: 0.82,
                    },
                    {
                        timeInSeconds: 3.5,
                        boxRaw: [
                            0.009852216748768475, 0.009722222222222215, 1.0208333333333333,
                            0.982456140350877,
                        ],
                        score: 0.81,
                    },
                    {
                        timeInSeconds: 4,
                        boxRaw: [
                            0.059113300492610835, 0.016666666666666663, 0.9427083333333334,
                            0.9047619047619048,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 4.5,
                        boxRaw: [
                            0.03694581280788177, 0.01944444444444443, 0.9479166666666666,
                            0.9147869674185464,
                        ],
                        score: 0.77,
                    },
                    {
                        timeInSeconds: 5,
                        boxRaw: [
                            0.01970443349753695, 0.018055555555555547, 0.9739583333333334,
                            0.9373433583959901,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 5.5,
                        boxRaw: [
                            0.02463054187192118, 0.016666666666666663, 0.9661458333333334,
                            0.9298245614035087,
                        ],
                        score: 0.77,
                    },
                    {
                        timeInSeconds: 6,
                        boxRaw: [
                            0.009852216748768475, 0.0111111111111111, 0.9791666666666666,
                            0.9398496240601504,
                        ],
                        score: 0.79,
                    },
                    {
                        timeInSeconds: 6.5,
                        boxRaw: [
                            0.01970443349753695, 0.0111111111111111, 0.953125,
                            0.9172932330827067,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 7,
                        boxRaw: [
                            0.02463054187192118, 0.015277777777777779, 0.9635416666666666,
                            0.9248120300751879,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 7.5,
                        boxRaw: [
                            0.027093596059113295, 0.018055555555555547, 0.984375,
                            0.949874686716792,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 8,
                        boxRaw: [
                            0.01231527093596059, 0.009722222222222215, 0.9895833333333334,
                            0.9523809523809523,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 8.5,
                        boxRaw: [
                            0.02463054187192118, 0.013888888888888895, 0.9713541666666666,
                            0.9323308270676693,
                        ],
                        score: 0.77,
                    },
                    {
                        timeInSeconds: 9,
                        boxRaw: [
                            0.034482758620689655, 0.020833333333333315, 0.9739583333333334,
                            0.9348370927318297,
                        ],
                        score: 0.79,
                    },
                    {
                        timeInSeconds: 9.5,
                        boxRaw: [
                            0.03201970443349754, 0.015277777777777779, 0.984375,
                            0.9473684210526315,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 10,
                        boxRaw: [
                            0.039408866995073885, 0.015277777777777779, 0.9739583333333334,
                            0.9348370927318297,
                        ],
                        score: 0.78,
                    },
                ],
            },
        ],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-02-thumb.jpg",
    },
    {
        segmentId: "clip-03",
        rotateAngleDegrees: 0,
        caption: {
            // intentionally leaving the subtitle empty so we can confirm that
            // captions look right in that case.
            title: "Emily",
        },
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-03.mp4",
        ],
        skipFace: false,
        durationSeconds: 41.007633,
        width: 1280,
        height: 720,
        faces: [
            {
                width: 736,
                height: 664,
                durationSeconds: 10,
                urls: [
                    "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-03-face.mp4",
                ],
                faceLocations: [
                    {
                        timeInSeconds: 0,
                        boxRaw: [
                            0.04921874999999998, 0.12222222222222223, 0.7214673913043478,
                            0.7996987951807228,
                        ],
                        score: 0.66,
                    },
                    {
                        timeInSeconds: 0.5,
                        boxRaw: [
                            0.0625, 0.1125, 0.7269021739130435, 0.8057228915662651,
                        ],
                        score: 0.68,
                    },
                    {
                        timeInSeconds: 1,
                        boxRaw: [0.0625, 0.10138888888888889, 0.75, 0.8313253012048193],
                        score: 0.67,
                    },
                    {
                        timeInSeconds: 1.5,
                        boxRaw: [
                            0.0625, 0.07083333333333333, 0.7241847826086957,
                            0.802710843373494,
                        ],
                        score: 0.7,
                    },
                    {
                        timeInSeconds: 2,
                        boxRaw: [
                            0.04062500000000002, 0.06527777777777778, 0.7404891304347826,
                            0.822289156626506,
                        ],
                        score: 0.73,
                    },
                    {
                        timeInSeconds: 2.5,
                        boxRaw: [
                            0.02031250000000001, 0.06944444444444445, 0.7445652173913043,
                            0.8253012048192772,
                        ],
                        score: 0.74,
                    },
                    {
                        timeInSeconds: 3,
                        boxRaw: [
                            0.037500000000000006, 0.08472222222222223, 0.7445652173913043,
                            0.8253012048192772,
                        ],
                        score: 0.72,
                    },
                    {
                        timeInSeconds: 3.5,
                        boxRaw: [
                            0.03984375000000001, 0.08055555555555556, 0.720108695652174,
                            0.7996987951807228,
                        ],
                        score: 0.75,
                    },
                    {
                        timeInSeconds: 4,
                        boxRaw: [
                            0.037500000000000006, 0.07222222222222223, 0.7255434782608695,
                            0.8057228915662651,
                        ],
                        score: 0.77,
                    },
                    {
                        timeInSeconds: 4.5,
                        boxRaw: [
                            0.024999999999999994, 0.07361111111111111, 0.7567934782608695,
                            0.838855421686747,
                        ],
                        score: 0.68,
                    },
                    {
                        timeInSeconds: 5,
                        boxRaw: [0, 0, 0.8654891304347826, 0.9593373493975904],
                        score: 0.69,
                    },
                    {
                        timeInSeconds: 5.5,
                        boxRaw: [
                            0.06484374999999998, 0.06805555555555556, 0.7119565217391305,
                            0.7876506024096386,
                        ],
                        score: 0.72,
                    },
                    {
                        timeInSeconds: 6,
                        boxRaw: [
                            0.08359375000000002, 0.07916666666666666, 0.6644021739130435,
                            0.7364457831325302,
                        ],
                        score: 0.76,
                    },
                    {
                        timeInSeconds: 6.5,
                        boxRaw: [
                            0.0078125, 0.020833333333333336, 0.8654891304347826,
                            0.9593373493975904,
                        ],
                        score: 0.64,
                    },
                    {
                        timeInSeconds: 7,
                        boxRaw: [
                            0.017187499999999994, 0.05694444444444445, 0.8478260869565217,
                            0.9382530120481928,
                        ],
                        score: 0.68,
                    },
                    {
                        timeInSeconds: 7.5,
                        boxRaw: [
                            0.06640625, 0.08472222222222223, 0.7581521739130435,
                            0.8418674698795181,
                        ],
                        score: 0.63,
                    },
                    {
                        timeInSeconds: 8,
                        boxRaw: [
                            0.014843749999999989, 0.03888888888888889, 0.8600543478260869,
                            0.9518072289156626,
                        ],
                        score: 0.74,
                    },
                    {
                        timeInSeconds: 8.5,
                        boxRaw: [
                            0.015625, 0.03888888888888889, 0.8546195652173914,
                            0.947289156626506,
                        ],
                        score: 0.72,
                    },
                    {
                        timeInSeconds: 9,
                        boxRaw: [
                            0.07500000000000001, 0.07222222222222223, 0.7432065217391305,
                            0.8237951807228916,
                        ],
                        score: 0.7,
                    },
                    {
                        timeInSeconds: 9.5,
                        boxRaw: [
                            0.07656249999999998, 0.025, 0.8668478260869565,
                            0.9623493975903614,
                        ],
                        score: 0.7,
                    },
                    {
                        timeInSeconds: 10,
                        boxRaw: [
                            0.12656250000000002, 0.11111111111111112, 0.6209239130434783,
                            0.6882530120481928,
                        ],
                        score: 0.75,
                    },
                ],
            },
        ],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-03-thumb.jpg",
    },
    {
        segmentId: "clip-04",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-04.mp4",
        ],
        skipFace: false,
        durationSeconds: 52.2,
        width: 1280,
        height: 720,
        faces: [],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-04-thumb.jpg",
    },
    {
        segmentId: "clip-05",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-05.mp4",
        ],
        skipFace: false,
        durationSeconds: 22.010998,
        width: 406,
        height: 720,
        faces: [
            {
                width: 400,
                height: 401,
                durationSeconds: 10,
                urls: [
                    "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-05-face.mp4",
                ],
                faceLocations: [
                    {
                        timeInSeconds: 0,
                        boxRaw: [
                            0.02955665024630542, 0.011111111111111113, 0.96,
                            0.9600997506234414,
                        ],
                        score: 0.79,
                    },
                    {
                        timeInSeconds: 0.5,
                        boxRaw: [
                            0.022167487684729068, 0.008333333333333331, 0.9675,
                            0.9650872817955112,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 1,
                        boxRaw: [
                            0.0270935960591133, 0.015277777777777779, 0.9525,
                            0.9501246882793017,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 1.5,
                        boxRaw: [0.019704433497536946, 0, 0.9675, 0.9675810473815462],
                        score: 0.73,
                    },
                    {
                        timeInSeconds: 2,
                        boxRaw: [
                            0.0270935960591133, 0.015277777777777779, 0.9525,
                            0.9501246882793017,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 2.5,
                        boxRaw: [
                            0.041871921182266014, 0.013888888888888895, 0.94,
                            0.9376558603491272,
                        ],
                        score: 0.77,
                    },
                    {
                        timeInSeconds: 3,
                        boxRaw: [
                            0.046798029556650245, 0.022222222222222213, 0.945,
                            0.942643391521197,
                        ],
                        score: 0.84,
                    },
                    {
                        timeInSeconds: 3.5,
                        boxRaw: [
                            0.049261083743842374, 0.008333333333333331, 0.9625,
                            0.9600997506234414,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 4,
                        boxRaw: [
                            0.049261083743842374, 0.023611111111111124, 0.9425,
                            0.9376558603491272,
                        ],
                        score: 0.85,
                    },
                    {
                        timeInSeconds: 4.5,
                        boxRaw: [
                            0.05172413793103449, 0.023611111111111124, 0.93,
                            0.9276807980049877,
                        ],
                        score: 0.81,
                    },
                    {
                        timeInSeconds: 5,
                        boxRaw: [
                            0.03201970443349754, 0.027777777777777776, 0.9525,
                            0.9476309226932669,
                        ],
                        score: 0.84,
                    },
                    {
                        timeInSeconds: 5.5,
                        boxRaw: [
                            0.022167487684729068, 0.011111111111111113, 0.96,
                            0.9600997506234414,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 6,
                        boxRaw: [
                            0.0024630541871921187, 0.023611111111111124, 0.9475,
                            0.9451371571072319,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 6.5,
                        boxRaw: [0, 0.023611111111111124, 0.9575, 0.9576059850374065],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 7,
                        boxRaw: [
                            0.054187192118226604, 0.022222222222222213, 0.9325,
                            0.9301745635910226,
                        ],
                        score: 0.81,
                    },
                    {
                        timeInSeconds: 7.5,
                        boxRaw: [
                            0.02955665024630542, 0.00972222222222223, 0.9575,
                            0.9551122194513716,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 8,
                        boxRaw: [
                            0.034482758620689655, 0.0069444444444444475, 0.96,
                            0.9600997506234414,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 8.5,
                        boxRaw: [
                            0.04433497536945813, 0.016666666666666663, 0.945,
                            0.942643391521197,
                        ],
                        score: 0.84,
                    },
                    {
                        timeInSeconds: 9,
                        boxRaw: [
                            0.046798029556650245, 0.015277777777777779, 0.9475,
                            0.9451371571072319,
                        ],
                        score: 0.83,
                    },
                    {
                        timeInSeconds: 9.5,
                        boxRaw: [
                            0.03694581280788177, 0.012499999999999997, 0.9625,
                            0.9625935162094763,
                        ],
                        score: 0.84,
                    },
                    {
                        timeInSeconds: 10,
                        boxRaw: [
                            0.024630541871921183, 0.002777777777777782, 0.9725,
                            0.970074812967581,
                        ],
                        score: 0.79,
                    },
                ],
            },
        ],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-05-thumb.jpg",
    },
    {
        segmentId: "clip-06",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-06.mp4",
        ],
        skipFace: false,
        durationSeconds: 61.415896,
        width: 1080,
        height: 720,
        faces: [
            {
                width: 793,
                height: 705,
                durationSeconds: 10.000000000000004,
                urls: [
                    "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-06-face.mp4",
                ],
                faceLocations: [
                    {
                        timeInSeconds: 0,
                        boxRaw: [
                            0.055555555555555566, 0.0027777777777777783, 0.862547288776797,
                            0.9716312056737588,
                        ],
                        score: 0.86,
                    },
                    {
                        timeInSeconds: 0.5,
                        boxRaw: [
                            0.06944444444444443, 0, 0.8776796973518285, 0.9886524822695035,
                        ],
                        score: 0.83,
                    },
                    {
                        timeInSeconds: 1,
                        boxRaw: [
                            0.10740740740740741, 0.016666666666666666, 0.8045397225725095,
                            0.9049645390070922,
                        ],
                        score: 0.84,
                    },
                    {
                        timeInSeconds: 1.5,
                        boxRaw: [
                            0.07962962962962962, 0.016666666666666666, 0.8007566204287514,
                            0.900709219858156,
                        ],
                        score: 0.83,
                    },
                    {
                        timeInSeconds: 2,
                        boxRaw: [
                            0.04814814814814815, 0.07222222222222223, 0.8675914249684742,
                            0.9744680851063829,
                        ],
                        score: 0.88,
                    },
                    {
                        timeInSeconds: 2.5,
                        boxRaw: [
                            0.03981481481481482, 0.0763888888888889, 0.862547288776797,
                            0.9702127659574468,
                        ],
                        score: 0.9,
                    },
                    {
                        timeInSeconds: 3,
                        boxRaw: [
                            0.0388888888888889, 0.06666666666666667, 0.8486759142496847,
                            0.9546099290780142,
                        ],
                        score: 0.91,
                    },
                    {
                        timeInSeconds: 3.5,
                        boxRaw: [
                            0.0324074074074074, 0.06527777777777778, 0.8650693568726355,
                            0.9730496453900709,
                        ],
                        score: 0.91,
                    },
                    {
                        timeInSeconds: 4,
                        boxRaw: [
                            0.05, 0.04583333333333334, 0.9041614123581336, 1.0184397163120567,
                        ],
                        score: 0.89,
                    },
                    {
                        timeInSeconds: 4.5,
                        boxRaw: [
                            0.046296296296296294, 0.04166666666666667, 0.9104665825977302,
                            1.0241134751773049,
                        ],
                        score: 0.9,
                    },
                    {
                        timeInSeconds: 5,
                        boxRaw: [
                            0.08796296296296298, 0.0638888888888889, 0.880201765447667,
                            0.9900709219858156,
                        ],
                        score: 0.89,
                    },
                    {
                        timeInSeconds: 5.5,
                        boxRaw: [
                            0.04166666666666667, 0.04583333333333334, 0.8902900378310215,
                            1.001418439716312,
                        ],
                        score: 0.85,
                    },
                    {
                        timeInSeconds: 6,
                        boxRaw: [
                            0.0388888888888889, 0.06666666666666667, 0.8398486759142497,
                            0.9446808510638298,
                        ],
                        score: 0.9,
                    },
                    {
                        timeInSeconds: 6.5000000000000036,
                        boxRaw: [
                            0.020370370370370386, 0.05416666666666667, 0.8638083228247163,
                            0.9716312056737588,
                        ],
                        score: 0.87,
                    },
                    {
                        timeInSeconds: 7.0000000000000036,
                        boxRaw: [
                            0.047222222222222235, 0.04444444444444445, 0.8839848675914249,
                            0.9957446808510638,
                        ],
                        score: 0.89,
                    },
                    {
                        timeInSeconds: 7.5000000000000036,
                        boxRaw: [
                            0.022222222222222213, 0.04722222222222222, 0.8789407313997478,
                            0.9886524822695035,
                        ],
                        score: 0.88,
                    },
                    {
                        timeInSeconds: 8.000000000000004,
                        boxRaw: [
                            0, 0.04583333333333334, 0.9117276166456494, 1.025531914893617,
                        ],
                        score: 0.83,
                    },
                    {
                        timeInSeconds: 8.500000000000004,
                        boxRaw: [
                            0.013888888888888881, 0.0638888888888889, 0.8915510718789408,
                            1.004255319148936,
                        ],
                        score: 0.92,
                    },
                    {
                        timeInSeconds: 9.000000000000004,
                        boxRaw: [
                            0.06574074074074075, 0.037500000000000006, 0.8701134930643127,
                            0.9801418439716312,
                        ],
                        score: 0.9,
                    },
                    {
                        timeInSeconds: 9.500000000000004,
                        boxRaw: [
                            0.06574074074074075, 0.03333333333333334, 0.8751576292559899,
                            0.9843971631205674,
                        ],
                        score: 0.9,
                    },
                    {
                        timeInSeconds: 10.000000000000004,
                        boxRaw: [
                            0.09537037037037037, 0.02638888888888889, 0.8133669609079445,
                            0.9148936170212766,
                        ],
                        score: 0.79,
                    },
                ],
            },
        ],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-06-thumb.jpg",
    },
    {
        segmentId: "clip-07",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-07.mp4",
        ],
        skipFace: false,
        durationSeconds: 49.966667,
        width: 1280,
        height: 720,
        faces: [
            {
                width: 565,
                height: 472,
                durationSeconds: 10,
                urls: [
                    "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-07-face.mp4",
                ],
                faceLocations: [
                    {
                        timeInSeconds: 0,
                        boxRaw: [
                            0.05390624999999999, -0.022222222222222223, 0.7628318584070797,
                            0.913135593220339,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 0.5,
                        boxRaw: [
                            0.09140624999999997, 0.022222222222222223, 0.6407079646017699,
                            0.7690677966101694,
                        ],
                        score: 0.7,
                    },
                    {
                        timeInSeconds: 1,
                        boxRaw: [
                            0.07734374999999999, 0.004166666666666667, 0.6778761061946903,
                            0.8114406779661016,
                        ],
                        score: 0.69,
                    },
                    {
                        timeInSeconds: 1.5,
                        boxRaw: [
                            0.07890625000000001, 0.006944444444444444, 0.6566371681415929,
                            0.7838983050847457,
                        ],
                        score: 0.66,
                    },
                    {
                        timeInSeconds: 2,
                        boxRaw: [
                            0.07265624999999998, 0.001388888888888889, 0.6884955752212389,
                            0.826271186440678,
                        ],
                        score: 0.68,
                    },
                    {
                        timeInSeconds: 2.5,
                        boxRaw: [
                            0.07656249999999998, 0.020833333333333332, 0.6672566371681415,
                            0.798728813559322,
                        ],
                        score: 0.74,
                    },
                    {
                        timeInSeconds: 3,
                        boxRaw: [
                            0.08749999999999997, 0.03194444444444444, 0.6123893805309735,
                            0.7351694915254238,
                        ],
                        score: 0.71,
                    },
                    {
                        timeInSeconds: 3.5,
                        boxRaw: [
                            0.06953124999999999, 0.005555555555555556, 0.7026548672566372,
                            0.8411016949152542,
                        ],
                        score: 0.68,
                    },
                    {
                        timeInSeconds: 4,
                        boxRaw: [
                            0.08515624999999999, 0.02361111111111111, 0.6442477876106195,
                            0.7733050847457628,
                        ],
                        score: 0.69,
                    },
                    {
                        timeInSeconds: 4.5,
                        boxRaw: [
                            0.05781249999999999, -0.006944444444444444, 0.7221238938053097,
                            0.8665254237288136,
                        ],
                        score: 0.68,
                    },
                    {
                        timeInSeconds: 5,
                        boxRaw: [
                            0.03593750000000001, -0.030555555555555555, 0.8035398230088495,
                            0.961864406779661,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 5.5,
                        boxRaw: [
                            0.06406249999999997, 0.002777777777777778, 0.7097345132743362,
                            0.8516949152542372,
                        ],
                        score: 0.71,
                    },
                    {
                        timeInSeconds: 6,
                        boxRaw: [
                            0.04921874999999998, -0.020833333333333332, 0.7858407079646018,
                            0.940677966101695,
                        ],
                        score: 0.73,
                    },
                    {
                        timeInSeconds: 6.5,
                        boxRaw: [
                            0.05859375, -0.016666666666666666, 0.7646017699115044,
                            0.9152542372881356,
                        ],
                        score: 0.83,
                    },
                    {
                        timeInSeconds: 7,
                        boxRaw: [
                            0.06406249999999997, -0.015277777777777777, 0.7469026548672566,
                            0.8940677966101694,
                        ],
                        score: 0.73,
                    },
                    {
                        timeInSeconds: 7.5,
                        boxRaw: [
                            0.09921874999999997, 0.015277777777777777, 0.6690265486725664,
                            0.8029661016949152,
                        ],
                        score: 0.69,
                    },
                    {
                        timeInSeconds: 8,
                        boxRaw: [
                            0.08515624999999999, 0.018055555555555554, 0.6548672566371682,
                            0.7838983050847457,
                        ],
                        score: 0.7,
                    },
                    {
                        timeInSeconds: 8.5,
                        boxRaw: [
                            0.07968749999999997, -0.004166666666666667, 0.6849557522123894,
                            0.8199152542372882,
                        ],
                        score: 0.68,
                    },
                    {
                        timeInSeconds: 9,
                        boxRaw: [
                            0, -0.09583333333333334, 0.9557522123893806, 1.146186440677966,
                        ],
                        score: 0.69,
                    },
                    {
                        timeInSeconds: 9.5,
                        boxRaw: [
                            0.05078125, -0.0875, 0.8849557522123894, 1.0593220338983051,
                        ],
                        score: 0.7,
                    },
                    {
                        timeInSeconds: 10,
                        boxRaw: [
                            0.07890625000000001, -0.02361111111111111, 0.8,
                            0.9576271186440678,
                        ],
                        score: 0.71,
                    },
                ],
            },
        ],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-07-thumb.jpg",
    },
    {
        segmentId: "clip-08",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-08.mp4",
        ],
        skipFace: false,
        durationSeconds: 39.82,
        width: 406,
        height: 720,
        faces: [
            {
                width: 336,
                height: 335,
                durationSeconds: 10,
                urls: [
                    "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-08-face.mp4",
                ],
                faceLocations: [
                    {
                        timeInSeconds: 0,
                        boxRaw: [
                            0.014778325123152705, 0.0222222222222222, 0.9047619047619048,
                            0.9044776119402985,
                        ],
                        score: 0.93,
                    },
                    {
                        timeInSeconds: 0.5,
                        boxRaw: [
                            0.014778325123152705, 0.0222222222222222, 0.9434523809523809,
                            0.9462686567164179,
                        ],
                        score: 0.91,
                    },
                    {
                        timeInSeconds: 1,
                        boxRaw: [
                            0.027093596059113295, 0.020833333333333315, 0.9404761904761905,
                            0.9432835820895522,
                        ],
                        score: 0.9,
                    },
                    {
                        timeInSeconds: 1.5,
                        boxRaw: [
                            0.022167487684729065, 0.01944444444444443, 0.9434523809523809,
                            0.9492537313432836,
                        ],
                        score: 0.89,
                    },
                    {
                        timeInSeconds: 2,
                        boxRaw: [
                            0.027093596059113295, 0.025000000000000022, 0.9226190476190477,
                            0.9223880597014925,
                        ],
                        score: 0.91,
                    },
                    {
                        timeInSeconds: 2.5,
                        boxRaw: [
                            0.027093596059113295, 0.013888888888888895, 0.9345238095238095,
                            0.9373134328358209,
                        ],
                        score: 0.91,
                    },
                    {
                        timeInSeconds: 3,
                        boxRaw: [
                            0.02463054187192118, 0.02777777777777779, 0.9107142857142857,
                            0.9134328358208955,
                        ],
                        score: 0.93,
                    },
                    {
                        timeInSeconds: 3.5,
                        boxRaw: [0, 0.009722222222222215, 0.9375, 0.9402985074626866],
                        score: 0.92,
                    },
                    {
                        timeInSeconds: 4,
                        boxRaw: [
                            0.03201970443349754, 0.018055555555555547, 0.9255952380952381,
                            0.9283582089552239,
                        ],
                        score: 0.92,
                    },
                    {
                        timeInSeconds: 4.5,
                        boxRaw: [
                            0.01724137931034482, 0.0111111111111111, 0.9494047619047619,
                            0.9492537313432836,
                        ],
                        score: 0.9,
                    },
                    {
                        timeInSeconds: 5,
                        boxRaw: [
                            0.007389162561576346, 0, 0.9851190476190477, 0.9880597014925373,
                        ],
                        score: 0.9,
                    },
                    {
                        timeInSeconds: 5.5,
                        boxRaw: [
                            0.022167487684729065, 0.008333333333333331, 0.9434523809523809,
                            0.9462686567164179,
                        ],
                        score: 0.91,
                    },
                    {
                        timeInSeconds: 6,
                        boxRaw: [
                            0.06157635467980295, 0.030555555555555558, 0.9255952380952381,
                            0.9283582089552239,
                        ],
                        score: 0.91,
                    },
                    {
                        timeInSeconds: 6.5,
                        boxRaw: [
                            0.04433497536945813, 0.036111111111111094, 0.9196428571428571,
                            0.9223880597014925,
                        ],
                        score: 0.91,
                    },
                    {
                        timeInSeconds: 7,
                        boxRaw: [
                            0.03201970443349754, 0.018055555555555547, 0.9107142857142857,
                            0.9134328358208955,
                        ],
                        score: 0.92,
                    },
                    {
                        timeInSeconds: 7.5,
                        boxRaw: [
                            0.02463054187192118, 0.025000000000000022, 0.9285714285714286,
                            0.9313432835820895,
                        ],
                        score: 0.92,
                    },
                    {
                        timeInSeconds: 8,
                        boxRaw: [
                            0.034482758620689655, 0.023611111111111083, 0.9345238095238095,
                            0.9373134328358209,
                        ],
                        score: 0.92,
                    },
                    {
                        timeInSeconds: 8.5,
                        boxRaw: [
                            0.01724137931034482, 0.023611111111111083, 0.9434523809523809,
                            0.9462686567164179,
                        ],
                        score: 0.92,
                    },
                    {
                        timeInSeconds: 9,
                        boxRaw: [
                            0.022167487684729065, 0.023611111111111083, 0.9255952380952381,
                            0.9283582089552239,
                        ],
                        score: 0.93,
                    },
                    {
                        timeInSeconds: 9.5,
                        boxRaw: [
                            0.02955665024630541, 0.015277777777777779, 0.9375,
                            0.9432835820895522,
                        ],
                        score: 0.91,
                    },
                    {
                        timeInSeconds: 10,
                        boxRaw: [
                            0.049261083743842374, 0.03194444444444444, 0.8958333333333334,
                            0.9014925373134328,
                        ],
                        score: 0.91,
                    },
                ],
            },
        ],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-08-thumb.jpg",
    },
    {
        segmentId: "clip-09",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-09.mp4",
        ],
        skipFace: false,
        durationSeconds: 41.9,
        width: 640,
        height: 480,
        faces: [],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-09-thumb.jpg",
    },
    {
        segmentId: "clip-10",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-10.mp4",
        ],
        skipFace: false,
        durationSeconds: 76.8,
        width: 1280,
        height: 720,
        faces: [
            {
                width: 437,
                height: 436,
                durationSeconds: 10,
                urls: [
                    "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-10-face.mp4",
                ],
                faceLocations: [
                    {
                        timeInSeconds: 0,
                        boxRaw: [
                            0.033593750000000006, 0.022222222222222227, 0.8466819221967964,
                            0.8486238532110091,
                        ],
                        score: 0.77,
                    },
                    {
                        timeInSeconds: 0.5,
                        boxRaw: [
                            0.03593750000000001, 0.02777777777777779, 0.8443935926773455,
                            0.8486238532110091,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 1,
                        boxRaw: [
                            0.03828125000000002, 0.02361111111111111, 0.8810068649885584,
                            0.8830275229357798,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 1.5,
                        boxRaw: [
                            0.025781250000000006, 0, 0.9244851258581236, 0.9288990825688074,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 2,
                        boxRaw: [
                            0.0390625, 0.026388888888888892, 0.8489702517162472,
                            0.8509174311926604,
                        ],
                        score: 0.79,
                    },
                    {
                        timeInSeconds: 2.5,
                        boxRaw: [
                            0.045312500000000006, 0.034722222222222224, 0.8146453089244852,
                            0.8188073394495413,
                        ],
                        score: 0.75,
                    },
                    {
                        timeInSeconds: 3,
                        boxRaw: [
                            0.03515625, 0.015277777777777779, 0.8581235697940504,
                            0.8600917431192661,
                        ],
                        score: 0.76,
                    },
                    {
                        timeInSeconds: 3.5,
                        boxRaw: [
                            0.03593750000000001, 0.03333333333333334, 0.8237986270022883,
                            0.8256880733944955,
                        ],
                        score: 0.76,
                    },
                    {
                        timeInSeconds: 4,
                        boxRaw: [
                            0.02734375, 0.029166666666666674, 0.8649885583524027,
                            0.8669724770642202,
                        ],
                        score: 0.79,
                    },
                    {
                        timeInSeconds: 4.5,
                        boxRaw: [
                            0.029687500000000006, 0.04027777777777777, 0.8535469107551488,
                            0.8577981651376148,
                        ],
                        score: 0.83,
                    },
                    {
                        timeInSeconds: 5,
                        boxRaw: [
                            0.03125, 0.04444444444444445, 0.8329519450800915,
                            0.8348623853211009,
                        ],
                        score: 0.83,
                    },
                    {
                        timeInSeconds: 5.5,
                        boxRaw: [
                            0.021093749999999994, 0.026388888888888892, 0.8947368421052632,
                            0.896788990825688,
                        ],
                        score: 0.84,
                    },
                    {
                        timeInSeconds: 6,
                        boxRaw: [
                            0.028906249999999994, 0.029166666666666674, 0.851258581235698,
                            0.853211009174312,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 6.5,
                        boxRaw: [
                            0.024999999999999994, 0.02361111111111111, 0.8787185354691075,
                            0.8807339449541285,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 7,
                        boxRaw: [
                            0.025781250000000006, 0.03333333333333334, 0.8558352402745996,
                            0.8577981651376148,
                        ],
                        score: 0.81,
                    },
                    {
                        timeInSeconds: 7.5,
                        boxRaw: [
                            0.0007812500000000111, 0.008333333333333345, 0.9702517162471396,
                            0.9724770642201835,
                        ],
                        score: 0.87,
                    },
                    {
                        timeInSeconds: 8,
                        boxRaw: [
                            0, 0.00972222222222223, 0.9816933638443935, 0.9839449541284404,
                        ],
                        score: 0.88,
                    },
                    {
                        timeInSeconds: 8.5,
                        boxRaw: [
                            0.01953125, 0.031944444444444456, 0.8947368421052632,
                            0.896788990825688,
                        ],
                        score: 0.86,
                    },
                    {
                        timeInSeconds: 9,
                        boxRaw: [
                            0.018750000000000017, 0.02500000000000001, 0.9084668192219679,
                            0.9105504587155964,
                        ],
                        score: 0.82,
                    },
                    {
                        timeInSeconds: 9.5,
                        boxRaw: [
                            0.012500000000000011, 0.015277777777777779, 0.9267734553775744,
                            0.926605504587156,
                        ],
                        score: 0.85,
                    },
                    {
                        timeInSeconds: 10,
                        boxRaw: [
                            0.01953125, 0.019444444444444445, 0.8993135011441648,
                            0.9013761467889907,
                        ],
                        score: 0.8,
                    },
                ],
            },
        ],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-10-thumb.jpg",
    },
    {
        segmentId: "clip-11",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-11.mp4",
        ],
        skipFace: false,
        durationSeconds: 40.859,
        width: 1280,
        height: 720,
        faces: [
            {
                width: 847,
                height: 662,
                durationSeconds: 10,
                urls: [
                    "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-11-face.mp4",
                ],
                faceLocations: [
                    {
                        timeInSeconds: 0,
                        boxRaw: [
                            0.02656249999999999, 0.018055555555555547, 0.8323494687131051,
                            1.0649546827794563,
                        ],
                        score: 0.64,
                    },
                    {
                        timeInSeconds: 0.5,
                        boxRaw: [
                            0.0390625, 0.02916666666666666, 0.8276269185360094,
                            1.0589123867069485,
                        ],
                        score: 0.72,
                    },
                    {
                        timeInSeconds: 1,
                        boxRaw: [
                            0.037500000000000006, 0.027777777777777776, 0.8394332939787486,
                            1.0725075528700907,
                        ],
                        score: 0.73,
                    },
                    {
                        timeInSeconds: 1.5,
                        boxRaw: [
                            0.03203124999999998, 0.022222222222222213, 0.8299881936245572,
                            1.0604229607250755,
                        ],
                        score: 0.68,
                    },
                    {
                        timeInSeconds: 2,
                        boxRaw: [
                            0.0390625, 0.02916666666666666, 0.8772136953955135,
                            1.122356495468278,
                        ],
                        score: 0.77,
                    },
                    {
                        timeInSeconds: 2.5,
                        boxRaw: [
                            0.02265624999999999, 0, 0.9362455726092089, 1.1993957703927491,
                        ],
                        score: 0.84,
                    },
                    {
                        timeInSeconds: 3,
                        boxRaw: [
                            0.016406249999999983, 0.02916666666666666, 0.9315230224321134,
                            1.191842900302115,
                        ],
                        score: 0.83,
                    },
                    {
                        timeInSeconds: 3.5,
                        boxRaw: [
                            0.010156250000000006, 0.07083333333333332, 0.9256198347107438,
                            1.1827794561933533,
                        ],
                        score: 0.84,
                    },
                    {
                        timeInSeconds: 4,
                        boxRaw: [
                            0.0015624999999999944, 0.006944444444444434, 0.9315230224321134,
                            1.191842900302115,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 4.5,
                        boxRaw: [
                            0.015625, 0.02638888888888888, 0.8961038961038961,
                            1.148036253776435,
                        ],
                        score: 0.77,
                    },
                    {
                        timeInSeconds: 5,
                        boxRaw: [
                            0, 0.043055555555555555, 0.9208972845336482, 1.1782477341389728,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 5.5,
                        boxRaw: [
                            0.014062500000000006, 0.04166666666666666, 0.9008264462809917,
                            1.151057401812689,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 6,
                        boxRaw: [
                            0.03046874999999999, 0.043055555555555555, 0.8689492325855962,
                            1.1117824773413898,
                        ],
                        score: 0.83,
                    },
                    {
                        timeInSeconds: 6.5,
                        boxRaw: [
                            0.033593750000000006, 0.04583333333333332, 0.8642266824085005,
                            1.1042296072507554,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 7,
                        boxRaw: [
                            0.033593750000000006, 0.04444444444444444, 0.8642266824085005,
                            1.107250755287009,
                        ],
                        score: 0.81,
                    },
                    {
                        timeInSeconds: 7.5,
                        boxRaw: [
                            0.0765625, 0.06388888888888887, 0.8229043683589138,
                            1.051359516616314,
                        ],
                        score: 0.77,
                    },
                    {
                        timeInSeconds: 8,
                        boxRaw: [
                            0.0875, 0.03611111111111111, 0.8299881936245572,
                            1.0634441087613293,
                        ],
                        score: 0.77,
                    },
                    {
                        timeInSeconds: 8.5,
                        boxRaw: [
                            0.084375, 0.004166666666666666, 0.872491145218418,
                            1.1163141993957701,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 9,
                        boxRaw: [
                            0.04374999999999998, 0.027777777777777776, 0.898465171192444,
                            1.149546827794562,
                        ],
                        score: 0.85,
                    },
                    {
                        timeInSeconds: 9.5,
                        boxRaw: [
                            0.05781249999999999, 0.04444444444444444, 0.8311688311688312,
                            1.0649546827794563,
                        ],
                        score: 0.76,
                    },
                    {
                        timeInSeconds: 10,
                        boxRaw: [
                            0.03984374999999998, 0.04166666666666666, 0.8441558441558441,
                            1.081570996978852,
                        ],
                        score: 0.81,
                    },
                ],
            },
        ],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-11-thumb.jpg",
    },
    {
        segmentId: "clip-12",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-12.mp4",
        ],
        skipFace: false,
        durationSeconds: 103.066667,
        width: 1280,
        height: 720,
        faces: [
            {
                width: 1015,
                height: 720,
                durationSeconds: 10,
                urls: [
                    "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-12-face.mp4",
                ],
                faceLocations: [
                    {
                        timeInSeconds: 0,
                        boxRaw: [
                            0.09999999999999999, -0.10138888888888889, 0.7270935960591133,
                            1.0263888888888888,
                        ],
                        score: 0.8,
                    },
                    {
                        timeInSeconds: 0.5,
                        boxRaw: [0.11015625, -0.075, 0.7004926108374384, 0.9875],
                        score: 0.82,
                    },
                    {
                        timeInSeconds: 1,
                        boxRaw: [
                            0.09765624999999999, -0.0763888888888889, 0.6886699507389162,
                            0.9694444444444444,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 1.5,
                        boxRaw: [
                            0.06093749999999999, -0.09166666666666666, 0.7330049261083744,
                            1.0347222222222223,
                        ],
                        score: 0.82,
                    },
                    {
                        timeInSeconds: 2,
                        boxRaw: [
                            0.0734375, -0.06111111111111111, 0.6935960591133005,
                            0.9777777777777777,
                        ],
                        score: 0.63,
                    },
                    {
                        timeInSeconds: 2.5,
                        boxRaw: [
                            0.04765625, -0.14166666666666666, 0.7694581280788177,
                            1.0847222222222221,
                        ],
                        score: 0.87,
                    },
                    {
                        timeInSeconds: 3,
                        boxRaw: [
                            0.03359374999999999, -0.1736111111111111, 0.865024630541872,
                            1.2180555555555554,
                        ],
                        score: 0.74,
                    },
                    {
                        timeInSeconds: 3.5,
                        boxRaw: [0, -0.3138888888888889, 1, 1.4111111111111112],
                        score: 0.82,
                    },
                    {
                        timeInSeconds: 4,
                        boxRaw: [0.075, -0.2111111111111111, 0.8512315270935961, 1.2],
                        score: 0.88,
                    },
                    {
                        timeInSeconds: 4.5,
                        boxRaw: [
                            0.12343749999999999, -0.1597222222222222, 0.729064039408867,
                            1.0277777777777777,
                        ],
                        score: 0.76,
                    },
                    {
                        timeInSeconds: 5,
                        boxRaw: [
                            0.14375, -0.02638888888888889, 0.5566502463054187,
                            0.7847222222222222,
                        ],
                        score: 0.75,
                    },
                    {
                        timeInSeconds: 5.5,
                        boxRaw: [
                            0.15078125000000003, 0.05694444444444444, 0.48669950738916257,
                            0.6861111111111111,
                        ],
                        score: 0.73,
                    },
                    {
                        timeInSeconds: 6,
                        boxRaw: [
                            0.16171875000000002, 0.0763888888888889, 0.4945812807881773,
                            0.6958333333333333,
                        ],
                        score: 0.76,
                    },
                    {
                        timeInSeconds: 6.5,
                        boxRaw: [
                            0.09609374999999999, -0.05277777777777778, 0.6886699507389162,
                            0.9708333333333333,
                        ],
                        score: 0.75,
                    },
                    {
                        timeInSeconds: 7,
                        boxRaw: [
                            0.09921875000000001, -0.06666666666666667, 0.7192118226600985,
                            1.0138888888888888,
                        ],
                        score: 0.72,
                    },
                    {
                        timeInSeconds: 7.5,
                        boxRaw: [
                            0.10625, -0.0625, 0.7064039408866996, 0.9958333333333333,
                        ],
                        score: 0.76,
                    },
                    {
                        timeInSeconds: 8,
                        boxRaw: [
                            0.10625, -0.08472222222222223, 0.69064039408867,
                            0.9722222222222222,
                        ],
                        score: 0.84,
                    },
                    {
                        timeInSeconds: 8.5,
                        boxRaw: [
                            0.06171875, -0.11527777777777778, 0.7940886699507389,
                            1.1194444444444445,
                        ],
                        score: 0.84,
                    },
                    {
                        timeInSeconds: 9,
                        boxRaw: [
                            0.075, -0.14166666666666666, 0.7931034482758621,
                            1.1180555555555556,
                        ],
                        score: 0.86,
                    },
                    {
                        timeInSeconds: 9.5,
                        boxRaw: [
                            0.07578125000000001, -0.1388888888888889, 0.7783251231527094,
                            1.0972222222222223,
                        ],
                        score: 0.85,
                    },
                    {
                        timeInSeconds: 10,
                        boxRaw: [
                            0.07421874999999999, -0.14444444444444443, 0.7694581280788177,
                            1.0833333333333333,
                        ],
                        score: 0.82,
                    },
                ],
            },
        ],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-12-thumb.jpg",
    },
    {
        segmentId: "clip-13",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-13.mp4",
        ],
        skipFace: false,
        durationSeconds: 61.266332,
        width: 1280,
        height: 720,
        faces: [
            {
                width: 722,
                height: 627,
                durationSeconds: 10.000000000000004,
                urls: [
                    "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-13-face.mp4",
                ],
                faceLocations: [
                    {
                        timeInSeconds: 0,
                        boxRaw: [
                            0.010156250000000033, 0.0111111111111111, 0.9321329639889196,
                            1.0749601275917064,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 0.5,
                        boxRaw: [
                            0.018750000000000044, 0.03749999999999998, 0.9224376731301939,
                            1.062200956937799,
                        ],
                        score: 0.78,
                    },
                    {
                        timeInSeconds: 1,
                        boxRaw: [
                            0.009375000000000022, 0.016666666666666663, 0.9445983379501385,
                            1.087719298245614,
                        ],
                        score: 0.82,
                    },
                    {
                        timeInSeconds: 1.5,
                        boxRaw: [
                            0.014843750000000044, 0.002777777777777768, 0.9722991689750693,
                            1.1196172248803828,
                        ],
                        score: 0.73,
                    },
                    {
                        timeInSeconds: 2,
                        boxRaw: [
                            0.01953125, 0.015277777777777751, 0.9307479224376731,
                            1.0717703349282297,
                        ],
                        score: 0.74,
                    },
                    {
                        timeInSeconds: 2.5,
                        boxRaw: [
                            0.02031250000000001, 0.01944444444444443, 0.9238227146814404,
                            1.0637958532695375,
                        ],
                        score: 0.79,
                    },
                    {
                        timeInSeconds: 3,
                        boxRaw: [
                            0.02031250000000001, 0.048611111111111105, 0.8988919667590027,
                            1.0350877192982457,
                        ],
                        score: 0.68,
                    },
                    {
                        timeInSeconds: 3.5,
                        boxRaw: [
                            0.005468750000000022, 0.016666666666666663, 0.9445983379501385,
                            1.0861244019138756,
                        ],
                        score: 0.74,
                    },
                    {
                        timeInSeconds: 4,
                        boxRaw: [
                            0.00390625, 0.012499999999999983, 0.9501385041551247,
                            1.0925039872408293,
                        ],
                        score: 0.77,
                    },
                    {
                        timeInSeconds: 4.5,
                        boxRaw: [
                            0.005468750000000022, 0.015277777777777751, 0.9473684210526315,
                            1.0925039872408293,
                        ],
                        score: 0.7,
                    },
                    {
                        timeInSeconds: 5,
                        boxRaw: [
                            0.021093750000000022, 0.029166666666666646, 0.9265927977839336,
                            1.0669856459330143,
                        ],
                        score: 0.72,
                    },
                    {
                        timeInSeconds: 5.5,
                        boxRaw: [
                            0.025781250000000033, 0.020833333333333315, 0.9044321329639889,
                            1.0414673046251994,
                        ],
                        score: 0.73,
                    },
                    {
                        timeInSeconds: 6,
                        boxRaw: [
                            0.01953125, 0.018055555555555547, 0.9307479224376731,
                            1.0717703349282297,
                        ],
                        score: 0.76,
                    },
                    {
                        timeInSeconds: 6.5000000000000036,
                        boxRaw: [
                            0.014062500000000033, 0.02638888888888888, 0.9224376731301939,
                            1.0606060606060606,
                        ],
                        score: 0.7,
                    },
                    {
                        timeInSeconds: 7.0000000000000036,
                        boxRaw: [
                            0.03359375000000003, 0.06805555555555554, 0.8130193905817175,
                            0.9362041467304625,
                        ],
                        score: 0.66,
                    },
                    {
                        timeInSeconds: 7.5000000000000036,
                        boxRaw: [
                            0.01171875, 0.012499999999999983, 0.9445983379501385,
                            1.087719298245614,
                        ],
                        score: 0.81,
                    },
                    {
                        timeInSeconds: 8.000000000000004,
                        boxRaw: [
                            0.017187500000000022, 0.008333333333333331, 0.9362880886426593,
                            1.0781499202551834,
                        ],
                        score: 0.73,
                    },
                    {
                        timeInSeconds: 8.500000000000004,
                        boxRaw: [
                            0.017968750000000033, 0.018055555555555547, 0.9085872576177285,
                            1.0478468899521531,
                        ],
                        score: 0.7,
                    },
                    {
                        timeInSeconds: 9.000000000000004,
                        boxRaw: [
                            0.010156250000000033, 0.03194444444444444, 0.9182825484764543,
                            1.0574162679425838,
                        ],
                        score: 0.71,
                    },
                    {
                        timeInSeconds: 9.500000000000004,
                        boxRaw: [
                            0.017187500000000022, 0.012499999999999983, 0.9058171745152355,
                            1.0446570972886762,
                        ],
                        score: 0.72,
                    },
                    {
                        timeInSeconds: 10.000000000000004,
                        boxRaw: [0, 0, 0.9307479224376731, 1.0717703349282297],
                        score: 0.7,
                    },
                ],
            },
        ],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-13-thumb.jpg",
    },
    {
        segmentId: "clip-14",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-14.mp4",
        ],
        skipFace: false,
        durationSeconds: 36.875,
        width: 360,
        height: 480,
        faces: [
            {
                width: 245,
                height: 243,
                durationSeconds: 10,
                urls: [
                    "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-14-face.mp4",
                ],
                faceLocations: [
                    {
                        timeInSeconds: 0,
                        boxRaw: [
                            0.10277777777777777, 0.024999999999999994, 0.8163265306122449,
                            0.8189300411522634,
                        ],
                        score: 0.94,
                    },
                    {
                        timeInSeconds: 0.5,
                        boxRaw: [
                            0.10555555555555554, 0.02291666666666667, 0.8244897959183674,
                            0.831275720164609,
                        ],
                        score: 0.93,
                    },
                    {
                        timeInSeconds: 1,
                        boxRaw: [
                            0.08888888888888888, 0.03125, 0.8448979591836734,
                            0.8477366255144033,
                        ],
                        score: 0.92,
                    },
                    {
                        timeInSeconds: 1.5,
                        boxRaw: [
                            0.09166666666666665, 0.02708333333333332, 0.8408163265306122,
                            0.8436213991769548,
                        ],
                        score: 0.94,
                    },
                    {
                        timeInSeconds: 2,
                        boxRaw: [
                            0.10277777777777777, 0.03749999999999998, 0.8122448979591836,
                            0.8189300411522634,
                        ],
                        score: 0.94,
                    },
                    {
                        timeInSeconds: 2.5,
                        boxRaw: [
                            0.05833333333333332, 0.05416666666666667, 0.8367346938775511,
                            0.8395061728395061,
                        ],
                        score: 0.95,
                    },
                    {
                        timeInSeconds: 3,
                        boxRaw: [
                            0.05555555555555555, 0.05000000000000002, 0.8367346938775511,
                            0.8477366255144033,
                        ],
                        score: 0.94,
                    },
                    {
                        timeInSeconds: 3.5,
                        boxRaw: [
                            0.06944444444444445, 0.04583333333333331, 0.8040816326530613,
                            0.8065843621399177,
                        ],
                        score: 0.95,
                    },
                    {
                        timeInSeconds: 4,
                        boxRaw: [
                            0.09722222222222224, 0.04166666666666666, 0.7918367346938775,
                            0.8024691358024691,
                        ],
                        score: 0.95,
                    },
                    {
                        timeInSeconds: 4.5,
                        boxRaw: [
                            0.09166666666666665, 0.047916666666666635, 0.8081632653061226,
                            0.8148148148148148,
                        ],
                        score: 0.94,
                    },
                    {
                        timeInSeconds: 5,
                        boxRaw: [
                            0.09166666666666665, 0.03958333333333333, 0.8489795918367345,
                            0.8559670781893004,
                        ],
                        score: 0.95,
                    },
                    {
                        timeInSeconds: 5.5,
                        boxRaw: [
                            0.09166666666666665, 0.03958333333333333, 0.8489795918367345,
                            0.8559670781893004,
                        ],
                        score: 0.95,
                    },
                    {
                        timeInSeconds: 6,
                        boxRaw: [
                            0.08055555555555555, 0.08541666666666667, 0.6612244897959184,
                            0.6666666666666666,
                        ],
                        score: 0.96,
                    },
                    {
                        timeInSeconds: 6.5,
                        boxRaw: [
                            0, 0.0958333333333333, 0.7387755102040816, 0.7448559670781894,
                        ],
                        score: 0.94,
                    },
                    {
                        timeInSeconds: 7,
                        boxRaw: [
                            0.033333333333333326, 0, 0.9142857142857143, 0.9218106995884774,
                        ],
                        score: 0.85,
                    },
                    {
                        timeInSeconds: 7.5,
                        boxRaw: [
                            0.03611111111111112, 0.029166666666666646, 0.9387755102040816,
                            0.9423868312757202,
                        ],
                        score: 0.89,
                    },
                    {
                        timeInSeconds: 8,
                        boxRaw: [
                            0.030555555555555558, 0.006249999999999978, 0.9346938775510204,
                            0.9423868312757202,
                        ],
                        score: 0.84,
                    },
                    {
                        timeInSeconds: 8.5,
                        boxRaw: [
                            0.04166666666666666, 0, 0.9387755102040816, 0.9423868312757202,
                        ],
                        score: 0.82,
                    },
                    {
                        timeInSeconds: 9,
                        boxRaw: [
                            0.01944444444444443, 0.010416666666666657, 0.9387755102040816,
                            0.9465020576131687,
                        ],
                        score: 0.85,
                    },
                    {
                        timeInSeconds: 9.5,
                        boxRaw: [
                            0.033333333333333326, 0.008333333333333331, 0.8979591836734695,
                            0.9053497942386831,
                        ],
                        score: 0.91,
                    },
                    {
                        timeInSeconds: 10,
                        boxRaw: [
                            0.030555555555555558, 0.010416666666666657, 0.8816326530612245,
                            0.8888888888888888,
                        ],
                        score: 0.9,
                    },
                ],
            },
        ],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-14-thumb.jpg",
    },
    {
        segmentId: "clip-15",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-15.mp4",
        ],
        skipFace: false,
        durationSeconds: 73.919,
        width: 1280,
        height: 720,
        faces: [],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-15-thumb.jpg",
    },
    {
        segmentId: "clip-16",
        rotateAngleDegrees: 0,
        caption: {},
        urls: [
            // this clip has not been normalized
            "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-16.mp4",
        ],
        skipFace: true,
        durationSeconds: 0.601995,
        width: 406,
        height: 920,
        faces: [],
        type: "video",
        trimNormalized: {
            start: 0,
            end: 1,
        },
        muteMusic: false,
        thumbnailSrc: "https://dev-static-assets.memento.com/compilations/sample-data/sample-set-01/clip-16-thumb.jpg",
    },
];
